<template>
     <div class="w-100" style="overflow: overlay !important;">
          <div class="header-outer">
               <span class="fw-500">Additional Info Creation Fields List</span>
          </div>
          <div class="pr-3">
               <div class="col-lg-12 col-sm-12 col-md-12">
               <div class="mt-4 d-flex justify-content-end" v-if="userPermissions.settings.permitted_actions.create">
                    <!-- <button class="btn btn-radius btn-secondary text-capitalize text-white" @click="AddFieldModal()">
                         + Add New Field
                    </button> -->
                    <button class="btn btn-radius btn-secondary text-capitalize text-white" @click="AddFieldModal()">
                         + Add New Field
                    </button>
               </div>
               </div>
               <!-- Table List View -->
               <div class="pt-4 overflow-auto ml-10 mr-4">
                    <table class="table table-content-data table-responsive">
                         <thead>
                              <tr>
                                   <th class="whiteSpace w-1">
                                        Field Name
                                   </th>
                                   <th class="whiteSpace">
                                        Field Type
                                   </th>
                                   <th class="whiteSpace">
                                        Visibility
                                   </th>
                                   <th class="whiteSpace">
                                        Data Type
                                   </th>
                                   <th class="whiteSpace"></th>
                              </tr>
                         </thead>
                         <tbody>
                              <tr class="w-100" v-if="ajax_call_in_progress && !allInfos.length">
                                   <td colspan="4">
                                        <div class="d-flex align-items-center justify-content-center w-100"
                                             v-if="ajax_call_in_progress">
                                             <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                  style="margin: 0 auto;" />
                                        </div>
                                   </td>
                              </tr>
                              <tr v-if="!ajax_call_in_progress && allInfos.length == 0"
                                   class="text-center font-weight-bold">
                                   <td colspan="4">No Additional Info Found</td>
                              </tr>
                              <tr v-for="(info, info_index) in allInfos" :key="info_index">
                                   <td class="whiteSpace w-1 text-capitalize">
                                        {{info.field_name}}
                                   </td>
                                   <td class="whiteSpace text-capitalize">
                                        {{info.field_type.replace('_',' ')}}
                                   </td>
                                   <td class="whiteSpace text-capitalize">
                                        <el-switch v-model="info.visibility"
                                             @change="changeStatus(info._id, info.visibility)"></el-switch>
                                   </td>
                                   <td class="whiteSpace text-capitalize" style="padding-right:2.2rem !important;">
                                        {{info.data_type.replace('_',' ')}}
                                   </td>
                                   <td class="table-admin admin-actions" style="padding-right:2.2rem !important;">
                                        <span class="pointer whiteSpace buttons">
                                             <button class="btn btn-icon actionicons update"
                                                  v-if="userPermissions.settings.permitted_actions.edit"
                                                  @click="editInfo(info._id)">
                                                  <el-tooltip class="item" effect="dark" content="Edit" trigger="hover"
                                                       placement="top">
                                                       <i class="icon icon-pencil text-white editIcon"></i>
                                                  </el-tooltip>
                                             </button>
                                             <button class="btn btn-icon actionicons close-order ml-2"
                                                  v-if="userPermissions.settings.permitted_actions.delete"
                                                  @click="deleteInfo(info._id)">
                                                  <el-tooltip class="item" effect="dark" content="Delete"
                                                       placement="top">
                                                       <i class="icon icon-delete text-white deleteIcon"></i>
                                                  </el-tooltip>
                                             </button>
                                        </span>
                                   </td>
                              </tr>
                         </tbody>
                    </table>
                    <!-- Pagination Section -->
                    <div class="d-flex justify-content-end align-items-center bg-white py-2"
                         style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px">
                         <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                              :options="pageLimit" :close-on-select="true" v-model.number="limit" :max-height="210"
                              open-direction="top" :show-labels="false"
                              :allow-empty="false" :block-keys="['Delete']" placeholder="" :searchable="false"
                              style="width: 4.2em !important;padding-right: 10px!important;">
                         </multiselect>
                         <span class="page-info pr-2 pl-2 fw-500 font-size-small">Per page</span>
                         <button @click="firstPage()" class="mt-1 pointer pagination-list" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0">
                              <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                   <i class="icon-chevron-double-left"></i>
                              </el-tooltip>
                         </button>
                         <button @click="previousPage()" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0"
                              class="pagination-list mt-1 ml-2 pointer">
                              <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                   <i class="icon icon-chevron-left"></i>
                              </el-tooltip>
                         </button>
                         <span class="px-2 fw-500 fs-14 mt-1 text-black font-size-small">Showing {{getSkipCount}} -
                              {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                         <button @click="nextPage()" :class="skip_temp >= total ? 'not-allowed' : 'pointer'" :disabled="skip_temp >= total"
                              class="pagination-list mt-1 mr-2 pointer">
                              <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                   <i class="icon icon-chevron-right"></i>
                              </el-tooltip>
                         </button>
                         <button @click="lastPage()" class="mt-1 pointer pagination-list"
                         :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                              <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                   <i class="icon-chevron-double-right"></i>
                              </el-tooltip>
                         </button>
                    </div>
               </div>
          </div>
          <add-new-field v-if="addfield" :sub_module_name="selected_module" @updateData="getAdditionalInfoList"
               @hide-add-field-modal="HideAddNewFieldsModal" :mode="mode" :info_id="info_id"
               modal_name="Add_Field_Modal"></add-new-field>
          <!-- <create-additional-modal v-if="add_field1" modal_name="CreateField"></create-additional-modal> -->
          <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}
          </sweet-modal>
          <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}
          </sweet-modal>
     </div>
     <!-- this.$route.params.id -->
</template>

<script>
     const AddNewField = () => import('./AddNewField');
     import {
          SweetModal
     } from 'sweet-modal-vue';
     // const CreateAdditionalModal = () => import('./CreateAddtionalModal')
     import settings from "../mixins/settings";
     import {
          HalfCircleSpinner
     } from "epic-spinners";
     export default ({
          mixins: [settings],
          props: ['selected_module'],
          data() {
               return {
                    visibility: true,
                    addfield: false,
                    allInfos: [],
                    skip: 0,
                    limit: 10,
                    search_key: '',
                    ajax_call_in_progress: false,
                    mode: '',
                    info_id: '',
                    success_msg: '',
                    warning_msg: '',
                    // add_field1: false,
                    toggle_visibility: '',
                    skip_temp: 0,
                    temp_total: 0,
                    count: 0,
                    pageLimit: [],
                    skip: 0,
                    start: 0,
                    end: 0,
                    total: 0,
               }
          },
          components: {
               AddNewField,
               HalfCircleSpinner,
               SweetModal,
               // CreateAdditionalModal,
          },
          methods: {
               //Pagination
               previousPage() {
                    this.temp_total = 0
                    this.skip_temp = 0
                    if (this.skip == 0) {
                         return;
                    }
                    this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                    this.getAdditionalInfoList();
               },
               nextPage() {
                    this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
                    if (this.skip_temp >= this.total) {
                         return;
                    }
                    this.skip = this.skip_temp;
                    this.getAdditionalInfoList();
               },
               firstPage() {
                    this.temp_total = 0
                    this.skip = 0
                    this.limit = this.limit
                    this.getAdditionalInfoList();
               },
               lastPage() {
                    this.skip_temp = 0
                    this.skip = 0
                    this.temp_total = this.total
                    let no_of_pages = Math.ceil(this.total / this.limit)
                    this.skip_temp = (no_of_pages * this.limit) - this.limit
                    if (this.skip_temp >= this.total) {
                         return;
                    }
                    this.skip = this.skip_temp
                    this.getAdditionalInfoList();
               },
               //Add field modal
               AddFieldModal() {
                    this.mode = 'create'
                    this.addfield = true
                    setTimeout(() => {
                         this.$modal.show('Add_Field_Modal')
                    }, 500)
               },
               //Edit Info modal
               editInfo(id) {
                    this.mode = 'edit'
                    this.info_id = id
                    this.addfield = true
                    setTimeout(() => {
                         this.$modal.show('Add_Field_Modal')
                    }, 500)
               },
               //hide the add new field modal
               HideAddNewFieldsModal() {
                    this.addfield = false
               },
               //API call to get the additional info list
               async getAdditionalInfoList() {
                    this.allInfos = []
                    this.ajax_call_in_progress = true;
                    try {
                         /**@params = limit, @params = skip, @params = search_key , @params = sort_key , @params = sort_vslue, @params = sub_module_name */
                         let params = {
                              limit: this.limit,
                              skip: this.skip,
                              search_key: this.search_key.trim(),
                              sort_key: '',
                              sort_value: -1,
                              sub_module_name: this.selected_module
                         }
                         let res = await this.getAdditionalInformationList(params)
                         this.allInfos = res.response
                         this.total = res.total;
                         this.ajax_call_in_progress = false;
                    } catch (error) {
                         // console.log(error)
                         this.ajax_call_in_progress = false;
                    }
               },
               //Api call to delete the info
               /**@params = selected_id */
               async deleteInfo(selected_id) {
                    let params = {
                         id: selected_id
                    }
                    let response = await this.DeleteAdditionalInformation(params);
                    this.success_msg = response
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                         this.$refs.success_modal.close();
                         this.getAdditionalInfoList();
                    }, 3000);
               },
               //Api call to cahnge the status
               /**@params = swtich_id, @params = type_value */
               async changeStatus(switch_id, type_value) {
                    if (this.userPermissions.settings.permitted_actions.edit) {
                         let params = {
                              id: switch_id,
                              type: type_value
                         }
                         let response = await this.UpdateVisibility(params);
                         this.toggle_visibility = response.response
                         this.success_msg = "Visibility Updated Successfully"
                         this.$refs.success_modal.open();
                         setTimeout(() => {
                              this.$refs.success_modal.close();
                              this.getAdditionalInfoList();
                         }, 3000);
                    } else {
                         this.$toasted.global.error("Permission Denied")
                    }
               }
          },
          created() {
               for (let i = 10; i <= 50; i += 10) {
                    this.pageLimit.push(i);
               }
          },
          mounted() {
               this.getAdditionalInfoList();
          },
          computed: {
               getSkipCount() {
                    if (this.total == 0) {
                         return 0
                    } else {
                         let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                         return skip_count;
                    }
               },
               userPermissions() {
                    return this.$store.getters.userPermissions;
               }
          },
          watch: {
               limit: function() {
                    this.getAdditionalInfoList();
               }
          },
     })
</script>

<style scoped>
     .header-outer {
          width: 100%;
          background: #00448b;
          color: #fff;
          font-size: 14px;
          padding-top: 10px;
          padding-bottom: 10px;
          padding-right: 20px;
          padding-left: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
     }

     .btn-radius {
          border-radius: 5px !important;
     }

     .table-properties {
          width: 100%;
          border-collapse: collapse;
     }

     .overflow-auto {
          overflow: overlay !important;
     }

     table thead {
          background-color: #00448b !important;
          color: #fff
     }

     .text-lightBlue {
          color: #00448b;
     }

     .actionicons.update {
          background: #00448b;
     }

     .actionicons.close-order {
          background: #f86c65;
     }

     .actionicons i {
          color: #fff;
          font-size: 15px !important;
          position: relative;
          bottom: 1px;
     }

     .actionicons i:hover {
          color: #fff !important;
     }

     .actionicons {
          border-radius: 4px !important;
          padding-left: 4px !important;
          padding-right: 4px !important;
     }


     .table-properties tbody td.table-status {
          width: 12%;
     }

     .table-properties tbody td.table-status-safari {
          width: 15% !important;
     }

     .table-properties tbody tr:hover td.table-status {
          display: none !important;
     }



     .table-admin .btn-icon {
          height: 2.1rem !important;
          line-height: 2.1rem !important;
          padding-top: 0 !important;
     }

     .table-properties tbody td.table-admin {
          display: none;
     }

     .table-properties tbody tr:hover td.table-admin {
          display: flex !important;
     }

     .table-properties tbody td.table-admin {
          display: none;
     }

     .table-properties tbody tr:hover td.table-admin {
          display: flex !important;
          border-bottom: 0;
     }


     .admin-actions .buttons {
          width: auto;
          text-align: left;
     }

     .table-properties tbody tr:nth-child(even) td.admin-actions .buttons {
          background-color: #ffff;
     }






     .table-content-data {
          position: relative;
          border-collapse: collapse;
          width: 100%;
     }

     .table-content-data tr th {
          padding: 14px 10px;
          font-weight: 500;
          line-height: 1.5;
          letter-spacing: 0.6px;
          text-transform: uppercase;
          color: #FFF;
          background-color: #00448b;
          font-size: 14px;
          white-space: nowrap;
     }

     .table-content-data tr td {
          border-bottom: solid 0.6px #d8d6e8;
          letter-spacing: 0.6px;
          color: #303031;
          padding: 6.5px 10px;
          white-space: nowrap;
     }

     .table-content-data tr td span a {
          text-decoration: none;
          color: #2196F3;
     }

     .table-content-data tbody tr td:first-child {
          padding: 0 25px;
     }

     .table-content-data tbody tr:hover {
          box-shadow: 0 3px 12px 0 rgba(96, 93, 93, 0.2);
          border: solid 1px #d8d6e8;
     }

     .table-content-data tbody td.table-admin {
          visibility: hidden;
     }

     .table-content-data tbody tr:hover td.table-status {
          display: none !important;
     }

     .table-content-data tbody tr:hover td.table-admin {
          visibility: visible !important;
          display: flex !important;
          border-bottom: 0;
     }

     .table-content-data thead tr th,
     .table-content-data tbody tr td {
          padding: 10px;
          text-transform: capitalize !important;
     }
     .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    @media only screen and (max-width: 655px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SettingsComponents/AdditionalInfo.vue